"use strict";

angular.module("imagetrend.components").directive("hlpFormSkill", [
    function() {
        return {
            restrict: "AE",
            scope: {
                component: "=?"
            },
            controller: [
                "$scope",
                "EXSkill",
                "$sce",
                function ($scope, EXSkill, $sce) {
                    $scope.skillsloading = true;
                    $scope.selectedskills = [];
                    $scope.skills = [];

                    $scope.trust = function (htmlText) {
                        //removing first pair of <p> tags to keep description on first line of skill
                        htmlText = (htmlText !== null) ? htmlText.replace('<p>', '').replace('</p>', '') : '';
                        return $sce.trustAsHtml(htmlText);
                    }

                    if ($scope.skills.length == 0) {
                        $scope.skillsloading = true;
                        EXSkill.get().then(function(Skills) {
                            for (var x in Skills) {
                                for (var y in Skills[x].options) {
                                    Skills[x].total_points +=
                                        Skills[x].options[y].points;
                                }
                                
                                if (Skills[x].max_points != null && Skills[x].max_points > 0)
                                    if (Skills[x].max_points < Skills[x].total_points)
                                        Skills[x].total_points = Skills[x].max_points;
                            }
                            $scope.skills = angular.copy(Skills);
                            $scope.setSelectedValues();
                        });
                    }

                    $scope.setSelectedValues = function() {
                        $scope.selectedskills = [];
                        $scope.component.skill_question_ids
                            .split(",")
                            .forEach(function(skillid) {
                                $scope.skills.forEach(function (skill) {
                                    if (skill.id == skillid.trim()) {
                                        skill.options.forEach(function (option) {
                                            if ($scope.component.skill_default == "1") {
                                                option.passed = 1;
                                            }
                                            if ($scope.component.skill_default == "2") {
                                                option.passed = 2;
                                            }
                                        })
                                        $scope.selectedskills.push(skill);
                                    }
                                });
                            });
                        $scope.tallyScores();
                        $scope.skillsloading = false;
                    };

                    $scope.determineClasses = function(isEven) {
                        var classes = "selectedSkill row no-margin";
                        if (isEven) classes += " even";

                        return classes;
                    };

                    $scope.getPassButtonClass = function (option) {
                        var classes = "btn btn-group ng-pristine ng-untouched ng-valid ng-binding ng-scope ng-empty btn-default";
                        if (option.passed == "1")
                            classes += " pass";
                        return classes;
                    };
                    $scope.getFaillButtonClass = function (option) {
                        var classes = "btn btn-group ng-pristine ng-untouched ng-valid ng-binding ng-scope ng-empty btn-default";
                        if (option.passed == "2")
                            classes += " fail";
                        return classes;
                    };

                    $scope.updateScore = function (option, passed) {
                        option.passed = passed
                        $scope.tallyScores();
                    };

                    $scope.tallyScores = function () {
                        $scope.selectedskills.forEach(function (skill) {
                            skill.talliedPoints = 0;
                            skill.options.forEach(function (option) {
                                if (option.passed == 1) {
                                    skill.talliedPoints += option.points;
                                    if (skill.talliedPoints > skill.total_points)
                                        skill.talliedPoints = skill.total_points;
                                }
                            })
                        })
                    };
                }
            ],
            replace: true,
            transclude: true,
            templateUrl:
                "templates/form-builder-form/form-skill/form-skill.html",
            link: function(scope, elem, attrs, ctrl) {}
        };
    }
]);
